export const DocumentCategory = {
  CurrentDocuments: 'Current Documents',
  PreviousDocuments: 'Previous Years Documents',
  OtherDocuments: 'Other Documents',
  LearningPathway: 'Learning Pathway'
}

